<template>

	<transition>
		<div class="bg" v-if="this.drawer && this.blur" @click="closeBackground ? toggleDrawer() : null" />
	</transition>
	
	<div class="drawer" 
		:class="
			{ 
				'position-absolute': keyboard, 
				'position-fixed': !keyboard, 
				'no-transition': keyboard,
				'hide-nav-drawer': hideNavBar
			}
			" 
		:style="'bottom: ' + bottom + '; background-color: ' + (drawer ? openBackgroundColor : backgroundColor) + '; height: ' + drawerHeight + '; transition: all ' + transitionDuration + ' ease-out;' + (safeAreaPadding ? ' padding-top: 44px;' : '')" 
		@click="toggleDrawer">
		<v-list-item class="drawer-header" style="text-align: center;">
			<div v-if="divider" class="divider"></div>
			<div v-else style="height: 16px;"></div>
			<v-row>
				<v-col cols="2">
					<div v-if="back" class="mg-circle-image-button" @click="event => { event.stopPropagation(); this.$emit('goBack') }"><v-icon icon="mdi-arrow-left"/></div>
					<div v-else-if="icon"><img :src="icon" class="cardIcon" /></div>
				</v-col>
				<v-col>
					<p class="title">{{ title }}</p>
				</v-col>
				<v-col cols="2">
					<div v-if="this.drawer && close" class="mg-circle-image-button" @click="event => { event.stopPropagation(); closeDrawer() }"><v-icon icon="mdi-close"/></div>
				</v-col>
			</v-row>
			
			
		</v-list-item>
		<v-divider v-if="divider"></v-divider>
		<div class="panelContent" @click="event => {event.stopPropagation()}">
			<slot v-if="drawer || contentAlwaysVisible" />
		</div>
	</div>
	
</template>

<script>
export default {
	name: "DrawerPanel",
	emits: ['opened', 'closed', 'goBack'],
	props: {
		title: { type: String },
		icon: { type: String },
		backgroundColor: { type: String },
		openBackgroundColor: { type: String },
		bottom: { type: String },
		openHeight: { type: String },
		closedHeight: { type: String },
		startOpened: { type: Boolean },
		blurBackground: { type: Boolean },
		back: { type: Boolean },
		contentAlwaysVisible: { type: Boolean },
		confirmClose: { type: Function },
		divider: { type: Boolean, default: true },
		close: { type: Boolean, default: true },
		keyboard: { type: Boolean, default: false },
		closeBackground: { type: Boolean, default: true },
		transitionDuration: { type: String, default: '0.3s' },
		safeAreaPadding: { type: Boolean, default: false },
		hideNavBar: { type: Boolean, default: false },
	},
	data() {
		return{
			drawerHeight: this.closedHeight ?? "82px",
			drawer:false,
			blur: true
		}
	},
	methods: {
		toggleDrawer: function() {
			if (!this.canCloseDrawer()) {
				return;
			}
			this.drawer = !this.drawer;
			if (!this.drawer)
			{
				this.drawerHeight = this.closedHeight ?? "82px";
				if (this.hideNavBar) {
					document.body.classList.remove('hide-nav-bar');
				}
				this.$emit("closed");
			}
			else
			{
				this.drawerHeight = this.openHeight ?? "80%";
				if (this.hideNavBar) {
					document.body.classList.add('hide-nav-bar');
				}
				this.$emit("opened");
			}
		},
		canCloseDrawer: function() {
			if (this.drawer && this.confirmClose && typeof this.confirmClose === 'function') {
				return this.confirmClose();
			}
			return true;
		},
		openDrawer: function() {
			this.drawer = true;
			this.drawerHeight = this.openHeight ?? "80%";
			if (this.hideNavBar) {
				document.body.classList.add('hide-nav-bar');
			}
			this.$emit("opened");
		},
		closeDrawer: function() {
			if (!this.canCloseDrawer()) {
				return;
			}

			this.drawer = false;
			this.drawerHeight = this.closedHeight ?? "82px";
			if (this.hideNavBar) {
				document.body.classList.remove('hide-nav-bar');
			}
			this.$emit("closed");
		},
		onLoad() {
			if (this.startOpened)
			{
				this.toggleDrawer();
			}
			if (this.blurBackground !== null && this.blurBackground !== undefined)
			{
				this.blur = this.blurBackground;
			} 
			else {
				this.blur = true;
			}
		}
	},
	watch: {
		openHeight(newHeight) {
			// Update drawer height if drawer is currently open
			if (this.drawer) {
				this.drawerHeight = newHeight ?? "80%";
			}
		}
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

	.cardIcon {
		height: 32px;
		width: 48px;
		border-radius: 8%;
		margin-left: 9px;
	}

	.panelContent {
		padding: 20px;
		padding-bottom: 150px;
		height: 100%;
		overflow-y: scroll;
	}

	.title{
		font-weight: bold;
	}

	.divider {
		width: 48px;
		margin-bottom: 8px;
		margin-top: 8px;
		margin-right: auto;
		margin-left: auto;
		background: var(--Keyline, rgba(51, 40, 71, 0.10));
		height: 4px;
		border-radius: 4px;
	}

	.drawer {
		border-radius: 16px 16px 0px 0px;
		border: 0px;
		overflow-y: hidden;
		width: 100%;
		left: 0px;
		transition: all .3s ease-out;
		z-index: 1000 !important;
	}

	.position-fixed {
		position: fixed;
	}

	.position-absolute {
		position: absolute;
		margin-bottom: 20px;
	}

	.no-transition {
		transition: none !important;
	}

	.hide-nav-drawer {
		display: block !important;
		z-index: 9999 !important;
	}

	.bg {
		z-index: 999 !important;
		position: fixed;
		width: 100vw;
		height: 100vh;
		top: 0px;
		left: 0px;
		background-color: #332847b5;
	}

	.mg-circle-image-button {
		float:left;
		background-color: #ffffff77;
		border-radius: 50% !important;
		height: 33px !important;
		width: 33px !important;
		padding-top: 7px !important;
		text-align: center;
		margin-top: -5px;
		font-size: 12px;
	}
</style>